import mixitup from 'mixitup';

let mixer = null;

let filter = {
	controls: null,
	filters: [],
	toggles: [],
	togglesNot: [],
	activeFilter: '',
	activeToggles: [],
	notToggles: [],
	dropdown: null,
	dropdownLabel: null,

	init: function () {
		let self = this;

		self.controls = $('.filter-controls');
		self.filters = self.controls.find('.filter[data-filter]');
		self.toggles = self.controls.find('.filter[data-toggle]');
		self.togglesNot = self.controls.find('.filter[data-toggle-not]');
		self.dropdown = self.controls.find('.filter-dropdown-container');
		self.dropdownLabel = self.controls.find('.filter-dropdown-label');

		self.filters.filter('.active').each(function () {
			self.activeFilter = $(this).attr('data-filter');
		});

		if (self.activeFilter == '') {
			let firstFilter = $(self.filters).first();
			firstFilter.addClass('active');
			self.activeFilter = firstFilter.attr('data-filter');
		}

		if (self.dropdownLabel !== null) {
			self.dropdownLabel.text($(self.filters).filter('.active').first().text());
		}

		self.toggles.filter('.active').each(function () {
			if ($(this).attr('data-toggle') != 'all') {
				self.activeToggles.push($(this).attr('data-toggle'));
			}
		});

		self.togglesNot.filter('.active').each(function () {
			if ($(this).attr('data-toggle-not') != 'all') {
				self.notToggles.push($(this).attr('data-toggle-not'));
			}
		});

		self.concatenateFilters();
		self.bindHandlers();
	},

	bindHandlers: function () {
		let self = this;

		// $(document.documentElement).on('click', function (event) {
		// 	self.dropdown.removeClass('filter-dropdown-open')
		// });

		self.dropdownLabel.on('click', function (event) {
			event.preventDefault();
			self.dropdown.toggleClass('filter-dropdown-open');
		});

		self.controls.on('click', '.filter', function (event) {
			event.preventDefault();
			let button = $(this);

			if (button.attr('data-filter')) {
				if (self.dropdownLabel !== null) {
					self.dropdownLabel.text(button.text());
					self.dropdown.removeClass('filter-dropdown-open');
				}

				if (!button.hasClass('active')) {
					button.addClass('active').siblings('.filter').removeClass('active');
				}
			} else if (button.attr('data-toggle')) {
				if (button.attr('data-toggle') == 'all') {
					button.addClass('active').siblings('.filter').removeClass('active');
				} else {
					button.parent().children('.filter[data-toggle="all"]').removeClass('active');
					button.toggleClass('active');

					if (button.parent().children('.active').length <= 0) {
						button.parent().children('.filter[data-toggle="all"]').addClass('active');
					}
					if (button.attr('data-single-select') && button.parent().children('.active').length > 1) {
						let activeItems = button.parent().children('.active');
						Array.from(activeItems).forEach(element =>{
							button.parent().children('.filter[data-toggle]').removeClass('active');
						});
						this.classList.add('active');
					}
				}
			} else if (button.attr('data-toggle-not')) {
				button.toggleClass('active');
				button.children('input').prop('checked', button.hasClass('active'));
			}

			self.parseFilters();
		});
	},

	parseFilters: function () {
		let self = this;
		self.activeToggles = [];
		self.notToggles = [];

		self.filters.filter('.active').each(function () {
			self.activeFilter = $(this).attr('data-filter');
		});

		self.toggles.filter('.active').each(function () {
			if ($(this).attr('data-toggle') != 'all') {
				self.activeToggles.push($(this).attr('data-toggle'));
			}
		});

		self.togglesNot.filter('.active').each(function () {
			if ($(this).attr('data-toggle-not') != 'all') {
				self.notToggles.push($(this).attr('data-toggle-not'));
			}
		});

		self.concatenateFilters();
	},

	concatenateFilters: function () {
		let self = this;
		let outputString = '';

		if (self.activeToggles.length > 0) {
			let outputArr = [];
			for (let i = 0, activeToggle; activeToggle = self.activeToggles[i]; i++) {
				outputArr.push(self.activeFilter + activeToggle);
			}
			outputString = outputArr.toString();
		} else {
			outputString = self.activeFilter;
		}

		if (self.notToggles.length > 0) {
			outputString += '.mix:not(' + self.notToggles.join('):not(') + ')';
		}

		// console.log(outputString);
		mixer.filter(outputString);
	}
};

if ($('.filter-container').length > 0) {
	mixer = mixitup('.filter-container', {
		controls: {
			enable: false
		},
		load: {
			filter: 'none'
		}
	});

	filter.init();
}
